import React from "react"
import { Row, Col, Grid, Divider } from 'antd'
import { Routes, Route } from "react-router-dom"
import SubscriptionsList from '../../Subscriptions/List'
import SubscriptionsPending from '../../Subscriptions/Pending'
import Payments from '../../Payments'
import Help from '../../Help'
import Legals from '../../Pages/Legals'
import Menu from './Menu'

const { useBreakpoint } = Grid

export default function LoggedIn() {
  const screens = useBreakpoint()

  return (
    <Row gutter={[0, 64]} >
      <Col
        xs={0}
        lg={8}
        className="ven-menu"
        style={{ paddingTop: screens.lg ? 32 : 0 }}
      >
        <Menu />
      </Col>

      <Col xs={24} lg={16} style={{ maxWidth: 1200, paddingTop: screens.lg ? 96 : 0, paddingLeft: screens.lg ? 32 : 0 }}>
        <Routes>
          <Route path="/" element={<SubscriptionsList />} />
          <Route path="/help" element={<div className="ven-content-text"><Help /></div>} />
          <Route path="/legals" element={<div className="ven-content-text"><Legals /></div>} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/success/:subscriptionId" element={<SubscriptionsPending />} />
        </Routes>
      </Col>

      <Col xs={24} lg={0} align='center'>
        <Divider />
        <Menu />
      </Col>

    </Row>
  )
}